/**
 * User Table Component
 * 
 * Displays a data table with user information using TanStack Table
 * - Generic DataTable component wrapper
 * - Pre-configured user columns
 * - Sorting and custom cell renderers
 * - Action button (edit only)
 * 
 * @component
 * @example
 * <UserTable
 *   users={users}
 *   loading={false}
 *   onEdit={(user) => console.log('Edit', user)}
 * />
 */

import { FC, useMemo } from 'react';
import DataTable from '@/components/DataTable/DataTable';
import { createUserColumns } from '@/components/DataTable/userColumns';
import type { UserTableProps } from './UserTable.types';

const UserTable: FC<UserTableProps> = ({
  users,
  loading = false,
  onEdit,
  onView,
}) => {
  // Create columns with actions memoized
  const columns = useMemo(
    () =>
      createUserColumns({
        onEdit,
        onView,
      }),
    [onEdit, onView]
  );

  return (
    <DataTable
      data={users}
      columns={columns}
      isLoading={loading}
      enableSorting={true}
      enablePagination={false}
      emptyMessage="Nenhum usuário encontrado"
      showSkeleton={true}
    />
  );
};

export default UserTable;
